import axios from 'axios'

import config from '../../config'

const createInspectionReminder = (params = {}, data) => {
  const { airportId } = params

  const url = `${config.baseUrl}/${airportId}/Reminders/Inspection`
  return axios.post(url, data)
}

export default createInspectionReminder
